import { Box, Divider, Text } from '@chakra-ui/react'
import { soapNoteField } from '@hb/shared'
import { useField } from 'react-final-form'
import { FormElement } from '../../../../components/forms'
import { SectionLabel } from '../../SectionLabel'

const MdmSummary = () => {
  const { input: assessmentInput } = useField('data.soapNote.assessment', {
    subscription: { value: true },
  })
  const { input: planInput } = useField('data.soapNote.plan', { subscription: { value: true } })

  const assessment = assessmentInput.value as string | undefined
  const plan = planInput.value as string | undefined

  if (!assessment && !plan) return null

  const parts: string[] = []
  if (assessment) parts.push(`Assessment: ${assessment.trim()}`)
  if (plan) parts.push(`Plan: ${plan.trim()}`)

  return (
    <>
      <Divider my={2} />
      <Box px={1} py={2}>
        <Text fontSize="xs" color="gray.500" fontStyle="italic">
          Clinical summary (auto-generated from Assessment and Plan):
        </Text>
        <Text fontSize="sm" mt={1} color="gray.700" _dark={{ color: 'gray.300' }}>
          {parts.join('. ')}
        </Text>
      </Box>
    </>
  )
}

export const SoapNoteInput = () => (
  <Box w="100%" data-child-name="data.soapNote" px={5} py="14px">
    <SectionLabel>SOAP Note</SectionLabel>
    <FormElement root showName={false} field={soapNoteField} name="data.soapNote" />
    <MdmSummary />
  </Box>
)
